import { Project } from '@leverege/api-redux';
import { GlobalState } from '@leverege/ui-redux';
export default class EnumAttributeValueSuggestor {
  constructor(type, opts = {}) {
    this.attribute = opts.attribute;
    this.delegate = opts.delegate;
    this.relationship = opts.relationship;
    this.objectType = opts.objectType;
  }
  getEnumValues() {
    const projectId = window.Molten.get('api')?.options?.projectId;
    const enumType = this.attribute?.blueprint?.attribute?.model?.enumType;
    const enumData = Project(projectId).enum(enumType).getEnum(GlobalState.get());
    return enumData?.values || [];
  }
  async suggest(value) {
    return this.getEnumValues();
  }
  getNameFor = value => {
    const values = this.getEnumValues();
    return values.find(v => v.value === value)?.name || value;
  };
}